import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { TechnicalDataOld, Vehicle } from '../../models/Vehicle';
import { Recall } from '../../models/Recalls';
import { makeVehicleApiRequest } from '../MakeVehicleApiRequestService/MakeVehicleApiRequestService';

export async function getShareVehicleData(
	url: string,
	apiKey: string,
	token: string,
): Promise<{ vehicle: Vehicle; technicalDetails: TechnicalDataOld; recalls: Recall[] } | undefined> {
	const headers = {
		'X-Api-Key': apiKey,
		'x-vin-token': '',
		'share-token': token.replace(/\+/g, '%2B').replace(/"/g, ''),
	};

	const response = await fetch(`${url}/api/vehicleData/share`, {
		method: 'GET',
		headers,
	});

	if (!response.ok) {
		throw new Error(`Request failed with status ${response.status}`);
	}

	return (await response.json()) as { vehicle: Vehicle; technicalDetails: TechnicalDataOld; recalls: Recall[] };
}

export async function getShareUrl(
	authService: IAuthServiceV2,
	resourceHostId: string,
	vin: string,
	productBrand: string,
	extendedDataRequest: boolean,
	language: string,
	bid: string,
	countryCode: string,
	url: string,
	apiKey: string,
	vinToken?: string,
): Promise<string> {
	return makeVehicleApiRequest<string>({
		authService,
		resourceHostId,
		url,
		endpoint: 'api/vehicleData/share',
		apiKey,
		vinToken,
		responseType: 'text', // <-- Override response parsing
		body: {
			vin,
			languageCode: language,
			extendedDataRequest,
			countryCode,
			bid,
			productBrand,
		},
	});
}
